module.exports = __webpack_public_path__ + "img/aljay-logo.39564764.png";